import { useState } from 'react';
import { GoogleGenerativeAI } from '@google/generative-ai';

// Initialize the API with your API key
const genAI = new GoogleGenerativeAI(import.meta.env.VITE_GEMINI_API_KEY);

export const useGemini = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState(null);

  const generateContent = async (prompt) => {
    try {
      setIsGenerating(true);
      setError(null);

      // Create a new model instance
      const model = genAI.getGenerativeModel({ model: 'gemini-2.0-flash' });

      // Format prompt correctly for the API
      const result = await model.generateContent({
        contents: [{
          parts: [{ text: prompt }]
        }]
      });

      if (!result || !result.response) {
        throw new Error('No response received');
      }

      const text = result.response.text();
      
      if (!text || text.trim().length === 0) {
        throw new Error('Empty response received');
      }

      return text;
    } catch (err) {
      console.error('Error:', err);
      let errorMessage = 'Failed to generate content. Please try again.';

      if (err.message.includes('API key')) {
        errorMessage = 'Invalid API key. Please check your configuration.';
      } else if (err.message.includes('quota')) {
        errorMessage = 'API quota exceeded. Please try again later.';
      } else if (err.message.includes('network')) {
        errorMessage = 'Network error. Please check your internet connection.';
      }

      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setIsGenerating(false);
    }
  };

  return {
    generateContent,
    isGenerating,
    error
  };
};
